/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProviderApiPushResponse { 
    message?: string;
    push_status?: ProviderApiPushResponse.PushStatusEnum;
}
export namespace ProviderApiPushResponse {
    export type PushStatusEnum = 'NO_OP' | 'SUCCESS' | 'FAILED';
    export const PushStatusEnum = {
        NO_OP: 'NO_OP' as PushStatusEnum,
        SUCCESS: 'SUCCESS' as PushStatusEnum,
        FAILED: 'FAILED' as PushStatusEnum
    };
}


